import { FormEvent, useState } from "react";
import { toast } from "react-toastify";
import Footer from "../../components/footer";
import NavBar from "../../components/navbar";
import { CSRFToken } from "../../services/auth";
import { createTopicApi } from "../../services/topic";

const CreateTopic = () => {
  const [topicTitle, setTopicTitle] = useState("");
  const [topicDesc, setTopicDesc] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("topicTitle", topicTitle);
      formData.append("topicDesc", topicDesc);

      const response = await createTopicApi(formData);
      if (response.status === 200) {
        toast.success("Successfully added new topic");
      } else {
        toast.error("Failed to add topic");
      }
    } catch (e) {
      toast.error("Failed to add topic");
    }
  };

  return (
    <>
      <NavBar />
      <div className="mt-20">
        <div className="flex flex-wrap">
          <div className="xl:mx-72 h-fit bg-white object-center shadow overflow-hidden sm:rounded-md w-5/6" >
            <form onSubmit={handleSubmit}>
              <div className="mt-5">
                Topic Title:
                <input
                  type="text"
                  name="topicTitle"
                  onChange={(e) => setTopicTitle(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
              <div className="mt-5">
                Topic Desc:
                <input
                  type="text"
                  name="topicTitle"
                  onChange={(e) => setTopicDesc(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  Create Topic
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CreateTopic;
